import { YM_ID } from '../../constants/data'

declare global {
  interface Window {
    ym: (...args: any[]) => void
  }
}

const set = (action: string, value: any): void => {
  window?.ym(YM_ID as string, action, value)
}

const setEvent = (action: string, value: any): void => {
  try {
    window?.ym(YM_ID as string, 'reachGoal', action, value)
  } catch (err) {
    console.warn('problem with setEvent Yandex', err)
  }
}

export default { set, setEvent }

//ОТ КУРСОРА

// // Утилиты для работы с Яндекс.Метрикой
// declare global {
//   interface Window {
//     ym?: (...args: any[]) => void
//     ymab?: (...args: any[]) => void
//     yandexABFlags?: any
//   }
// }

// export const set = (target: string, params: any) => {
//   if (typeof window !== 'undefined' && window.ym) {
//     try {
//       window.ym(target, 'reachGoal', params)
//     } catch (err) {
//       console.warn('problem with set Yandex', err)
//     }
//   }
// }

// export const setEvent = (target: string, params: any) => {
//   if (typeof window !== 'undefined' && window.ym) {
//     try {
//       window.ym(target, 'reachGoal', params)
//     } catch (err) {
//       console.warn('problem with setEvent Yandex', err)
//     }
//   }
// }

// // Функция для получения флагов A/B тестирования
// export const getYandexABFlags = (counterId: string, flagName: string): Promise<any> => {
//   return new Promise((resolve) => {
//     if (typeof window === 'undefined') {
//       resolve({ [flagName]: ['old'] })
//       return
//     }

//     // Проверяем, есть ли уже загруженные флаги
//     if (window.yandexABFlags) {
//       console.log('Using preloaded AB flags:', window.yandexABFlags)
//       resolve(window.yandexABFlags)
//       return
//     }

//     const getFlags = () => {
//       if (typeof window.ymab !== 'function') {
//         // Если ymab еще не загружен, пробуем снова через 100мс
//         setTimeout(getFlags, 100)
//         return
//       }

//       try {
//         window.ymab(`metrika.${counterId}`, 'getFlags', function (flags: any) {
//           console.log('Yandex AB Flags loaded:', flags)
//           // Сохраняем флаги для последующего использования
//           window.yandexABFlags = flags
//           resolve(flags || { [flagName]: ['old'] })
//         })
//       } catch (error) {
//         console.error('Error getting Yandex AB flags:', error)
//         resolve({ [flagName]: ['old'] })
//       }
//     }

//     // Пробуем получить флаги сразу
//     getFlags()

//     // Также слушаем событие загрузки страницы
//     const handleLoad = () => {
//       // Даем дополнительное время для загрузки скриптов
//       setTimeout(getFlags, 500)
//     }

//     if (document.readyState === 'loading') {
//       document.addEventListener('DOMContentLoaded', handleLoad)
//     } else {
//       handleLoad()
//     }
//   })
// }

// // Функция для ожидания загрузки ymab
// export const waitForYandexMetrika = (): Promise<void> => {
//   return new Promise((resolve) => {
//     if (typeof window === 'undefined') {
//       resolve()
//       return
//     }

//     if (typeof window.ymab === 'function') {
//       resolve()
//       return
//     }

//     const checkYandexMetrika = () => {
//       if (typeof window.ymab === 'function') {
//         resolve()
//       } else {
//         setTimeout(checkYandexMetrika, 100)
//       }
//     }

//     checkYandexMetrika()
//   })
// }

// // Функция для ожидания загрузки флагов
// export const waitForABFlags = (): Promise<any> => {
//   return new Promise((resolve) => {
//     if (typeof window === 'undefined') {
//       resolve({ new_bar: ['old'] })
//       return
//     }

//     // Если флаги уже загружены и валидны
//     if (window.yandexABFlags && isValidFlags(window.yandexABFlags)) {
//       console.log('Using preloaded AB flags:', window.yandexABFlags)
//       resolve(window.yandexABFlags)
//       return
//     }

//     // Функция для проверки валидности флагов
//     function isValidFlags(flags: any): boolean {
//       if (!flags || typeof flags !== 'object') return false

//       // Проверяем, что есть хотя бы один валидный флаг
//       for (const key in flags) {
//         if (flags[key] && Array.isArray(flags[key]) && flags[key].length > 0) {
//           return true
//         }
//       }
//       return false
//     }

//     // Функция для получения флагов с повторными попытками
//     function getFlagsWithRetry(attempts = 0, maxAttempts = 15) {
//       if (typeof window.ymab !== 'function') {
//         if (attempts < maxAttempts) {
//           setTimeout(() => getFlagsWithRetry(attempts + 1, maxAttempts), 200)
//           return
//         } else {
//           console.warn('ymab not available after max attempts, using fallback')
//           resolve({ new_bar: ['old'] })
//           return
//         }
//       }

//       try {
//         window.ymab(`metrika.${process.env.YM_ID || 'default'}`, 'getFlags', function (flags: any) {
//           console.log('Attempt', attempts + 1, 'Yandex AB Flags:', flags)

//           if (isValidFlags(flags)) {
//             console.log('Valid AB Flags loaded:', flags)
//             window.yandexABFlags = flags
//             resolve(flags)
//             return
//           }

//           // Если флаги еще не готовы, пробуем снова
//           if (attempts < maxAttempts) {
//             console.log('Flags not ready yet, retrying in 300ms...')
//             setTimeout(() => getFlagsWithRetry(attempts + 1, maxAttempts), 300)
//           } else {
//             console.warn('Max attempts reached, using fallback flags')
//             const fallbackFlags = { new_bar: ['new'] }
//             window.yandexABFlags = fallbackFlags
//             resolve(fallbackFlags)
//           }
//         })
//       } catch (error) {
//         console.error('Error getting Yandex AB flags:', error)
//         if (attempts < maxAttempts) {
//           setTimeout(() => getFlagsWithRetry(attempts + 1, maxAttempts), 300)
//         } else {
//           const fallbackFlags = { new_bar: ['old'] }
//           resolve(fallbackFlags)
//         }
//       }
//     }

//     // Слушаем событие загрузки флагов
//     const handleFlagsLoaded = (event: CustomEvent) => {
//       window.removeEventListener('yandexABFlagsLoaded', handleFlagsLoaded as EventListener)
//       if (isValidFlags(event.detail)) {
//         console.log('AB Flags loaded via event:', event.detail)
//         resolve(event.detail)
//       } else {
//         console.warn('Invalid flags from event, falling back to retry logic')
//         getFlagsWithRetry()
//       }
//     }

//     window.addEventListener('yandexABFlagsLoaded', handleFlagsLoaded as EventListener)

//     // Начинаем попытки получения флагов
//     getFlagsWithRetry()

//     // Таймаут на случай, если ничего не сработает
//     setTimeout(() => {
//       window.removeEventListener('yandexABFlagsLoaded', handleFlagsLoaded as EventListener)
//       console.warn('Timeout reached, using fallback flags')
//       resolve({ new_bar: ['old'] })
//     }, 10000) // Увеличиваем таймаут до 10 секунд
//   })
// }

// // Функция для отладки состояния Яндекс.Метрики
// export const debugYandexMetrika = () => {
//   if (typeof window === 'undefined') {
//     console.log('Debug: Running on server side')
//     return
//   }

//   console.log('=== Yandex Metrika Debug Info ===')
//   console.log('window.ym exists:', typeof window.ym === 'function')
//   console.log('window.ymab exists:', typeof window.ymab === 'function')
//   console.log('window.yandexABFlags:', window.yandexABFlags)
//   console.log('document.readyState:', document.readyState)

//   if (window.yandexABFlags) {
//     console.log('Flags keys:', Object.keys(window.yandexABFlags))
//     for (const key in window.yandexABFlags) {
//       console.log(`Flag ${key}:`, window.yandexABFlags[key])
//     }
//   }

//   console.log('================================')
// }

// // Функция для принудительного обновления флагов
// export const forceRefreshFlags = (counterId: string): Promise<any> => {
//   return new Promise((resolve) => {
//     if (typeof window === 'undefined' || typeof window.ymab !== 'function') {
//       resolve({ new_bar: ['old'] })
//       return
//     }

//     console.log('Force refreshing AB flags...')
//     window.ymab(`metrika.${counterId}`, 'getFlags', function (flags: any) {
//       console.log('Force refresh result:', flags)
//       if (flags && typeof flags === 'object' && Object.keys(flags).length > 0) {
//         window.yandexABFlags = flags
//         window.dispatchEvent(new CustomEvent('yandexABFlagsLoaded', { detail: flags }))
//         resolve(flags)
//       } else {
//         resolve({ new_bar: ['old'] })
//       }
//     })
//   })
// }

// export default { set, setEvent }
